import { Box, Divider, Flex, Heading, Text, Tag } from '@chakra-ui/react';
import useAuth from '../hooks/useAuth';
import { FaRegUser } from 'react-icons/fa';
import React, { useMemo } from 'react';
import { RoleToString } from '../domain/Role';

const UserAvatar = () => {
  const { user } = useAuth();

  return (
    <Box
      aria-hidden="true"
      data-testid="user-avatar"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexShrink={0}
      padding=".6em"
      borderRadius="full"
      backgroundColor="info.800">
      <Text
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="1em"
        height="1em"
        lineHeight="1"
        fontSize="xxl"
        color="primary.200"
        textTransform="uppercase"
        fontWeight="light">
        {user?.name.charAt(0)}
      </Text>
    </Box>
  );
};

const RoleBadge = () => {
  const { user } = useAuth();

  const userRoles = useMemo(() => {
    const roles = user?.roles || [];
    return roles.map(role => RoleToString(role)).filter(role => role !== '');
  }, [user]);

  return (
    <>
      {userRoles.map(ur =>
        <Tag key={ur} colorScheme="gray" color="neutral.500" alignItems="center" marginLeft="l">
          <FaRegUser />
          <Text marginLeft="0.5em">{ur}</Text>
        </Tag>
      )}
    </>
  );
};

function Header() {
  const { user } = useAuth();

  const date = useMemo(() => {
    return (new Date()).toLocaleString('es-MX', { dateStyle: 'full' });
  }, []);

  return (
    <>
      <Flex justifyContent="space-between" flexDirection="row" alignItems={'center'}>
        <Flex flexDirection={'column'}>
          <Heading as="h1" size="md" paddingBottom={3}>¡Hola {user?.name}!</Heading>
          <Flex alignItems="center">
            {date} | {<RoleBadge />}
          </Flex>
        </Flex>
        <UserAvatar />
      </Flex>
      <Divider marginTop={'15px'} borderColor={'neutral.300'} />
    </>
  );
}

export default Header;
